// src/pages/ReflectionPage.tsx
import React, { useState, useEffect } from 'react';
import { scoringApi } from '../api';
import type { Reflection } from '../types';

function currentYM() {
  const d = new Date(Date.now() + 7*3600000);
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
}

export default function ReflectionPage() {
  const [month, setMonth]       = useState(currentYM());
  const [existing, setExisting] = useState<Reflection | null>(null);
  const [q1, setQ1]             = useState('');
  const [q2, setQ2]             = useState('');
  const [q3, setQ3]             = useState('');
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState('');

  useEffect(() => {
    scoringApi.getReflection(month).then(({ reflection }) => {
      if (reflection) {
        setExisting(reflection);
        setQ1(reflection.whatWorked);
        setQ2(reflection.whatGotInTheWay);
        setQ3(reflection.oneThing);
      } else {
        setExisting(null); setQ1(''); setQ2(''); setQ3('');
      }
    }).catch(() => {});
  }, [month]);

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      await scoringApi.saveReflection(month, q1, q2, q3);
      setMsg('Reflection saved.');
    } catch (e: any) { setMsg(e.response?.data?.error || 'Failed'); }
    setSaving(false);
  };

  return (
    <div>
      <div style={{ fontSize:26, fontWeight:600, letterSpacing:-0.5, marginBottom:6 }}>Reflection</div>
      <div style={{ fontSize:12, color:'var(--text3)', fontFamily:'var(--font-mono)', marginBottom:24 }}>
        Personal — only visible to you
      </div>

      <div style={{ marginBottom:24 }}>
        <input type="month" value={month} onChange={e => setMonth(e.target.value)}
          style={{ padding:'7px 12px', background:'var(--bg3)', border:'1px solid var(--border2)',
            borderRadius:'var(--radius-sm)', color:'var(--text)', fontSize:12,
            fontFamily:'var(--font-mono)', outline:'none' }} />
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16, maxWidth:640 }}>
        <ReflectionQ q="What worked this month?" value={q1} onChange={setQ1}
          placeholder="What habits or strategies helped you succeed?" />
        <ReflectionQ q="What got in the way?" value={q2} onChange={setQ2}
          placeholder="What made it hard? Any patterns you noticed?" />
        <ReflectionQ q="One thing to do differently next month" value={q3} onChange={setQ3}
          placeholder="One concrete change..." />
      </div>

      {msg && <div style={{ fontSize:11, color: msg.includes('saved') ? 'var(--green)' : 'var(--red)', margin:'12px 0' }}>{msg}</div>}

      <button onClick={save} disabled={saving || (!q1 && !q2 && !q3)} style={{
        marginTop:16, padding:'10px 24px', borderRadius:'var(--radius-sm)', fontSize:13,
        background:'var(--green)', border:'none', color:'#0c0e14', fontWeight:600, cursor:'pointer',
        opacity: (!q1 && !q2 && !q3) ? 0.5 : 1,
      }}>
        {saving ? 'Saving...' : existing ? 'Update reflection' : 'Save reflection'}
      </button>
    </div>
  );
}

function ReflectionQ({ q, value, onChange, placeholder }: {
  q: string; value: string; onChange: (v: string) => void; placeholder: string;
}) {
  return (
    <div>
      <label style={{ display:'block', fontSize:12, fontWeight:500, color:'var(--text2)', marginBottom:8 }}>{q}</label>
      <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={3}
        style={{ width:'100%', padding:'10px 12px', background:'var(--bg3)',
          border:'1px solid var(--border2)', borderRadius:'var(--radius-md)',
          color:'var(--text)', fontSize:12, outline:'none', resize:'vertical',
          fontFamily:'var(--font-ui)', lineHeight:1.6 }}
        onFocus={e => e.target.style.borderColor = 'var(--purple)'}
        onBlur={e  => e.target.style.borderColor = 'var(--border2)'}
      />
    </div>
  );
}
